"use client";

import { Layout } from 'antd';
import styles from './WhereUsed.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const whereUsedData = [
  {
    id: 1,
    title: "title1",
    desc: "desc1",
  },
  {
    id: 2,
    title: "title2",
    desc: "desc2",
  },
  {
    id: 3,
    title: "title3",
    desc: "desc3",
  },
];

export const WhereUsed = () => {
  const t = useTranslations('aiAgent.whereUsed');

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title')}</h1>
        <h4>{t('desc')}</h4>
      </ScrollReveal>

      <ScrollReveal className={styles.root_cards}>
        {whereUsedData.map(item =>
          <section key={item.id} className={styles.root_cards_item}>
            <div className={styles.line} />
            <h5>{t(item.title)}</h5>
            <h6>{t(item.desc)}</h6>
          </section>
        )}
      </ScrollReveal>
    </Content>
  );
};
